import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useIsAdminUser } from 'components/user/UserProvider';
import { Category, GradeLevel, Platform, Subject, Technology } from 'models';
import Approval from 'models/Approval';
import React, { ChangeEvent } from 'react';
import { FilterState } from '../../Search';
import FilterMultivalue from './components/FilterMultivalue';
import FilterSingleValue from './components/FilterSingleValue';
import { FilterOption } from './components/types';

const getOptions = (field: any): FilterOption[] => {
  return Object.values(field).map((item) => ({
    label: item as string,
    value: item as string,
  }));
};

interface Props {
  filterState: FilterState;
  handleChange: (event: ChangeEvent<{ name: string; value: unknown }>) => void;
}

const Filters: React.FC<Props> = ({ filterState, handleChange }) => {
  const isAdminUser = useIsAdminUser();

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6">Filters</Typography>
      </Grid>
      <Grid item xs={12}>
        <FilterMultivalue
          optionList={getOptions(GradeLevel)}
          id="gradeLevel"
          label="Grade Level"
          value={filterState.selectedGradeLevel}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <FilterSingleValue
          optionList={getOptions(Subject)}
          id="subject"
          label="Subject"
          value={filterState.selectedSubject}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <FilterSingleValue
          optionList={getOptions(Platform)}
          id="platform"
          label="Platform"
          value={filterState.selectedPlatform}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <FilterSingleValue
          optionList={getOptions(Category)}
          id="category"
          label="Category"
          value={filterState.selectedCategory}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12}>
        <FilterSingleValue
          optionList={getOptions(Technology)}
          id="technology"
          label="Technology"
          value={filterState.selectedTechnology}
          onChange={handleChange}
        />
      </Grid>
      {isAdminUser && (
        <Grid item xs={12}>
          <FilterSingleValue
            optionList={[
              { label: 'Approved', value: Approval.Approved },
              { label: 'Unapproved', value: Approval.Unapproved },
            ]}
            id="approval"
            label="Approval"
            value={filterState.selectedApproval}
            onChange={handleChange}
          />
        </Grid>
      )}
    </>
  );
};

export default Filters;
